import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../media';

export const ConfiguratorsListingSection = styled.section`
	width: 100%;
`;

export const pageTitleStyles = css`
	${breakpoints.to.largeDesktop} {
		margin-bottom: 32px;
	}
	${breakpoints.to.tablet} {
		margin-bottom: 24px;
	}
`;
